
export default function ProductScope() {
  const modules = [
    { name: 'Health & Safety', icon: 'ri-heart-pulse-line', description: 'Incident reporting, hazard management, safety inductions' },
    { name: 'Asset Management', icon: 'ri-truck-line', description: 'Equipment tracking, maintenance schedules, inventory' },
    { name: 'Quality Management', icon: 'ri-award-line', description: 'Inspection workflows, non-conformance tracking' },
    { name: 'Template Management', icon: 'ri-file-copy-line', description: 'Centralized template library for forms and checklists' },
    { name: 'Document Management', icon: 'ri-folder-5-line', description: 'Version control, approval workflows, access management' },
    { name: 'Incident Reporting', icon: 'ri-alarm-warning-line', description: 'Real-time capture, investigation workflows' },
    { name: 'Form Builders', icon: 'ri-draft-line', description: 'Custom form creation, conditional logic, offline capability' }
  ];

  return (
    <section className="py-20" style={{ background: 'linear-gradient(180deg, #182423 0%, #2a3d3b 100%)' }}>
      <div className="max-w-6xl mx-auto px-6">
        <div className="text-center mb-16">
          <span className="inline-block px-4 py-2 rounded-full text-sm font-semibold mb-4" style={{ backgroundColor: '#F16051', color: 'white' }}>
            Platform Features
          </span>
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
            Product Scope & Key Modules
          </h2>
          <p className="text-xl text-white/70 max-w-3xl mx-auto">
            Seven critical construction management systems consolidated into a single, unified platform
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-12">
          {modules.slice(0, 4).map((module, index) => (
            <div 
              key={index} 
              className="group bg-white/10 backdrop-blur-sm rounded-2xl p-6 border border-white/10 hover:bg-white/20 transition-all duration-300"
            >
              <div className="w-12 h-12 rounded-xl flex items-center justify-center mb-4 group-hover:scale-110 transition-transform duration-300" style={{ backgroundColor: '#F16051' }}>
                <i className={`${module.icon} text-white text-xl`}></i>
              </div>
              <h3 className="text-lg font-bold text-white mb-2">{module.name}</h3>
              <p className="text-sm text-white/60">{module.description}</p>
            </div>
          ))}
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 gap-4 mb-12">
          {modules.slice(4).map((module, index) => (
            <div 
              key={index} 
              className="group bg-white/10 backdrop-blur-sm rounded-2xl p-6 border border-white/10 hover:bg-white/20 transition-all duration-300"
            >
              <div className="w-12 h-12 rounded-xl flex items-center justify-center mb-4 group-hover:scale-110 transition-transform duration-300" style={{ backgroundColor: '#F16051' }}>
                <i className={`${module.icon} text-white text-xl`}></i>
              </div>
              <h3 className="text-lg font-bold text-white mb-2">{module.name}</h3>
              <p className="text-sm text-white/60">{module.description}</p>
            </div>
          ))}
        </div>

        {/* Dashboard Preview */}
        <div className="bg-white/10 backdrop-blur-sm rounded-3xl p-8 border border-white/10">
          <div className="flex items-center gap-3 mb-6">
            <div className="w-3 h-3 rounded-full bg-red-400"></div>
            <div className="w-3 h-3 rounded-full bg-yellow-400"></div>
            <div className="w-3 h-3 rounded-full bg-green-400"></div>
            <span className="text-white/40 text-sm ml-2">Dashboard Preview</span>
          </div>
          <div className="aspect-video bg-white/5 rounded-2xl flex items-center justify-center border border-white/10">
            <div className="text-center">
              <div className="w-20 h-20 rounded-2xl flex items-center justify-center mx-auto mb-4" style={{ backgroundColor: '#F16051' }}>
                <i className="ri-dashboard-3-line text-white text-4xl"></i>
              </div>
              <p className="text-white/60">Unified dashboard showing all modules</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
